import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

function About() {
  const [pageContent, setPageContent] = useState('');
  const [galleryItems, setGalleryItems] = useState([]);

  useEffect(() => {
    apiService.getPageBySlug('about')
      .then(response => {
        if (response.data.page) {
          setPageContent(response.data.page.content);
        }
      })
      .catch(error => console.error('Error loading about page:', error));

    apiService.getGallery()
      .then(response => setGalleryItems(response.data.gallery))
      .catch(error => console.error('Error loading gallery:', error));
  }, []);

  return (
    <div className="about-page">
      <section 
        className="hero-section" 
        style={{
          backgroundImage: galleryItems.filter(item => item.file_type === 'image').length > 0 
            ? `url(${galleryItems.filter(item => item.file_type === 'image')[0]?.file_path})` 
            : 'none',
          height: '60vh'
        }}
      >
        <div className="hero-content">
          <h1 className="hero-title">ABOUT US</h1>
        </div>
      </section>

      <section className="section section-light">
        <div className="container">
          <div className="two-column">
            <div>
              <h2 className="section-title">OUR STORY</h2>
              <p className="section-text">{pageContent}</p>
            </div>
            <div>
              {galleryItems.filter(item => item.file_type === 'image').length > 0 && (
                <img 
                  src={galleryItems.filter(item => item.file_type === 'image')[0]?.file_path} 
                  alt="About Yamas" 
                  className="content-image"
                  onError={(e) => {
                    console.error('Image failed to load');
                    e.target.style.display = 'none';
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
